import {
  CREATE_SUB_ASSEMBLY_SUCCESS,
  FETCH_SUB_ASSEMBLY_SUCCESS,
  GET_SUB_ASSEMBLY_SUCCESS,
  SAVE_SUB_ASSEMBLY_QUERY
} from "../../constants/ActionTypes";

const INIT_STATE = {
  total: 0,
  resources: [],
  resource: {},
  edit: {},
  query: {},
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SAVE_SUB_ASSEMBLY_QUERY: {
      return {
        ...state,
        query: action.query
      }
    }

    case GET_SUB_ASSEMBLY_SUCCESS: {
      const query = {...state.query};
      query.pagination.total = action.count;

      return {
        ...state,
        query: query,
        resources: action.data,
        total: action.count,
      }
    }

    case CREATE_SUB_ASSEMBLY_SUCCESS: {
      return {
        ...state,
        resource: action.data,
      }
    }

    case FETCH_SUB_ASSEMBLY_SUCCESS: {
      return {
        ...state,
        edit: action.data,
      }
    }


    default:
      return state;
  }
}
